import React, { useState } from "react";
import { users } from "../../data/users";
import { FormGroup, StatusDot, FormFooter, Button, Input, DatePickerInput } from "xsolla-uikit";
import CardNew from "../PAcardNew";
import PAtabs from "../PAtabs";
import PAh2 from "../PAh2";
import { CssLineHover, CssSelectStatus, CssTh } from '../uikit2';
import { CssPopGrid, CssSelectItems } from "./PAusersSubscribers";
export function PAusersSubsPop({ title, handleModal, index = 0 }) {
  const [tab, setTab] = useState("email");
  const [columns, setColumns] = useState([]);
  return (<FormGroup>


    <FormGroup indentation="xs">
      <CardNew wave={false}>
        <CssPopGrid className="">
          <FormGroup label="Status" indentation="xs">
            <CssSelectItems>
              <CssSelectStatus>
                <StatusDot status="enabled"></StatusDot>
              </CssSelectStatus>{" "}
              Active
              </CssSelectItems>
          </FormGroup>

          <FormGroup label="User Email" indentation="xs">
            {users[index]["email"]}
          </FormGroup>

          <FormGroup label="Last charge" indentation="xs">
            199.99 USD
            </FormGroup>
        </CssPopGrid>
      </CardNew>
    </FormGroup>

    <FormGroup>
      <PAtabs
        // appearance="secondary"
        active="email" handleTab={nw => {
          setTab(nw);
        }} items={[
          { name: "User email", stateName: "email" },
          { name: "Next invoice date", stateName: "date" },
          { name: "Transactions", stateName: "trans" }
          // {name: 'Actions',
          // stateName: 'action'},
        ]} />
    </FormGroup>


    <FormGroup>
      <PAh2 tag="h4" title="Change email" />

      <FormGroup>
        <FormGroup label="Old user email">
          <Input dock="left" disabled={true} input={{
            value: users[index]["email"]
          }} />
        </FormGroup>

        <FormGroup label="New user email">
          <Input placeholder="newmail@mail.com" input={{
            value: null
          }} />
        </FormGroup>
        <FormFooter ignoreCentered={true}>
          <Button appearance="secondary" disabled={true}>
            Save
            </Button>
        </FormFooter>
      </FormGroup>
    </FormGroup>



    <FormGroup>
      <PAh2 tag="h4" title="Change renewal date" />
      <FormGroup>
        <FormGroup label="Old user email">
          <Input disabled={true} input={{
            value: "May 3, 2020"
          }} />
        </FormGroup>
        <FormGroup label="New user email">
          <DatePickerInput name="single" input={{
            onChange: () => {
              void 0;
            }
          }} size="sm" pickTime={true} />
        </FormGroup>
        <FormFooter ignoreCentered={true}>
          <Button appearance="secondary" disabled={true}>
            Save changes
            </Button>
        </FormFooter>
      </FormGroup>
    </FormGroup>



    <FormGroup>
      <PAh2 tag="h4" title="Related transactions" />
      <FormGroup>
        <CssLineHover>
          <CssTh cols="">
            <div className="transaction-registry-list__cell--hoverable transaction-registry-list__cell--inline">
              <div className="xsui-status-dot xsui-status-dot--active">
                <div className="xsui-status-dot__icon" />
                <div className="xsui-status-dot__entry" />
              </div>
              482748117
              </div>
            <div>09/30/2019 1:30 PM</div>
            <div>ID 22877</div>
            <div>EUR&nbsp;59.99</div>
            <div className="transaction-registry-list__cell--extra">
              Credit/Debit Cards (EUR)
              </div>
          </CssTh>
        </CssLineHover>

        <CssLineHover>
          <CssTh>
            <div className="transaction-registry-list__cell--hoverable transaction-registry-list__cell--inline">
              <div className="xsui-status-dot xsui-status-dot--active">
                <div className="xsui-status-dot__icon" />
                <div className="xsui-status-dot__entry" />
              </div>
              482748117
              </div>
            <div>09/30/2019 1:30 PM</div>
            <div>ID 22877</div>
            <div>EUR&nbsp;59.99</div>
            <div className="transaction-registry-list__cell--extra">
              Credit/Debit Cards (EUR)
              </div>
          </CssTh>
        </CssLineHover>

        <CssLineHover>
          <CssTh>
            <div className="transaction-registry-list__cell--hoverable transaction-registry-list__cell--inline">
              <div className="xsui-status-dot xsui-status-dot--active">
                <div className="xsui-status-dot__icon" />
                <div className="xsui-status-dot__entry" />
              </div>
              482748117
              </div>
            <div>09/30/2019 1:30 PM</div>
            <div>ID 22877</div>
            <div>EUR&nbsp;59.99</div>
            <div className="transaction-registry-list__cell--extra">
              Credit/Debit Cards (EUR)
              </div>
          </CssTh>
        </CssLineHover>
      </FormGroup>
    </FormGroup>





  </FormGroup>);
}
